<template>
  <div class="auth-reset">
    <b-container>
      <b-row align-h="center">
        <b-col md="8">
          <b-card header="パスワード再発行">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <b-form-group label="メールアドレス" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorEmail name="メールアドレス" :form="$v.form.email" />
                </b-col>
              </b-form-group>
              <b-form-group label="認証コード" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorText name="認証コード" :form="$v.form.code" />
                </b-col>
              </b-form-group>
              <b-form-group label="新しいパスワード:" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorPassword name="新しいパスワード" :form="$v.form.password" badge showStrengthMeter />
                </b-col>
              </b-form-group>
              <b-form-group label="(再入力):" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorPassword name="新しいパスワード(再入力)" :form="$v.form.retype_password" />
                </b-col>
              </b-form-group>

              <b-form-group>
                <b-col md="6" offset-md="4">
                  <b-button type="submit" variant="primary">更新</b-button>
                  <b-button type="reset" variant="outline-primary">リセット</b-button>
                </b-col>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'AuthReset',

  computed: {
    ...mapState({
      form: state => state.auth.regist,
    }),
  },

  validations: {
    form: {
      email: {
        required,
        email,
        maxLength: maxLength(255),
      },
      code: {
        required,
        minLength: minLength(16),
        maxLength: maxLength(16),
      },
      password: {
        required,
        maxLength: maxLength(72),
      },
      retype_password: {
        required,
        maxLength: maxLength(72),
        sameAs: sameAs('password'),
      },
    },
  },

  mounted() {
    this.$store.dispatch('auth/registLoad', {
      email: this.$route.params.email,
      code: this.$route.params.code,
    });
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.$store.dispatch('auth/regist', {
        form: this.form,
        callback: (data) => {
          this.$v.form.$reset();
          this.$store.dispatch('auth/registClear');
        },
      });
    },

    onReset(evt) {
      this.$v.form.$reset();
      this.$store.dispatch('auth/registLoad', {
        email: this.$route.params.email,
        code: this.$route.params.code,
      });
    },
  },
};
</script>

<style scoped>
</style>
